var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.252,
    height: 30,
    viewBox: "0 0 28.252 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_71",
    "data-name": "Rect\\xE1ngulo 71",
    width: 28.252,
    height: 30,
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_180",
    "data-name": "Trazado 180",
    d: "M20.779,9.8a2.93,2.93,0,0,1,1.811.586,2.725,2.725,0,0,1,1.074,2.234c.012,4.507.014,5.72,0,10.229a2.755,2.755,0,0,1-2.829,2.814q-6.749.017-13.5,0a2.757,2.757,0,0,1-2.828-2.815c-.013-4.508-.014-5.722,0-10.229A2.773,2.773,0,0,1,7.366,9.8c.521,0,12.9-.007,13.414,0m-4.653,6.639H12.04v2.722h4.087Zm0-4.453H12.041v2.379h4.086ZM12.035,23.611h4.1v-2.37h-4.1Zm-5.473-4.45h3.4V16.433h-3.4Zm15.049-2.724h-3.4v2.731h3.4ZM9.972,11.989H6.559v2.369H9.972Zm8.243,2.373h3.4v-2.38h-3.4Zm-.006,6.867v2.4c.939,0,1.859.016,2.778-.008.422-.01.63-.274.641-.719.01-.36,0-.721,0-1.082v-.586Zm-11.665,0c0,.539,0,1.058,0,1.578,0,.573.244.819.812.822.8,0,1.6,0,2.393,0,.072,0,.144-.013.216-.02v-2.38Z",
    transform: "translate(0.041 0.088)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_181",
    "data-name": "Trazado 181",
    d: "M8.072,0A1.512,1.512,0,0,1,9.586,1.514V4.036h9.081V1.514a1.514,1.514,0,0,1,3.027,0V4.036h2.523a4.038,4.038,0,0,1,4.036,4.036V25.964A4.039,4.039,0,0,1,24.216,30H4.036A4.038,4.038,0,0,1,0,25.964V8.072A4.036,4.036,0,0,1,4.036,4.036H6.559V1.514A1.512,1.512,0,0,1,8.072,0M25.225,8.39H3.027V25.964a1.01,1.01,0,0,0,1.009,1.009h20.18a1.012,1.012,0,0,0,1.009-1.009Z",
    transform: "translate(0 0)",
    fill: "#20164d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8838c0c999c78f1c9bae7dfc254fc074.svg";
export { ForwardRef as ReactComponent };